import client from '../client';
import type { AnalyticalLink, CreateAnalyticalLinkInput } from '../../types/analyticalLink';
import type { Order } from '../../types/order';
import type { ApiResponse, PaginationParams } from '../../types/api';

interface AnalyticalLinkListParams extends PaginationParams {
  // extend later with filters if needed
}

export const analyticalLinksApi = {
  list: async (storeId: string, params?: AnalyticalLinkListParams) => {
    const res = await client.get<ApiResponse<{ links: AnalyticalLink[]; total?: number; page?: number; limit?: number; pagination?: { total: number; page: number; limit: number } }>>(
      `/dashboard/${storeId}/analytical-links`,
      { params },
    );
    const d = res.data.data!;
    return {
      links: d.links || [],
      total: d.pagination?.total ?? d.total ?? d.links?.length ?? 0,
      page: d.pagination?.page ?? d.page ?? 1,
      limit: d.pagination?.limit ?? d.limit ?? 50,
    };
  },

  getOrders: async (storeId: string, linkId: string, params?: PaginationParams) => {
    const res = await client.get<ApiResponse<any>>(
      `/dashboard/${storeId}/analytical-links/${linkId}/orders`,
      { params },
    );
    const d = res.data.data!;
    return {
      orders: (d.orders || []) as Order[],
      total: d.pagination?.total ?? d.total ?? 0,
      page: d.pagination?.page ?? d.page ?? 1,
      limit: d.pagination?.limit ?? d.limit ?? 20,
    };
  },

  create: async (storeId: string, data: CreateAnalyticalLinkInput) => {
    const res = await client.post<ApiResponse<{ link: AnalyticalLink }>>(
      `/dashboard/${storeId}/analytical-links`,
      data,
    );
    return res.data.data!;
  },

  delete: async (storeId: string, linkId: string): Promise<void> => {
    await client.delete(`/dashboard/${storeId}/analytical-links/${linkId}`);
  },
};
